import React, { useContext, useEffect, useState, useRef } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import { Button, Label, Modal, Select } from "flowbite-react";
import GlobalContext from "../connections/GlobalContext";
import Head_data from "../components/Head_data";
import Button_submit from "../components/Button_submit";
import engineGif from "../image/engine.gif";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const SpareRequests = ({ theme }) => {
  const { globalValue } = useContext(GlobalContext);
  const [lowSpares, setLowSpares] = useState([]);
  const [relatedSpareRecord, setRelatedSpareRecord] = useState([]);
  const [selectedSpareForRequest, setSelectedSpareForRequest] = useState(null);
  const [requestQuantity, setRequestQuantity] = useState("");
  const [selectedEstimateId, setSelectedEstimateId] = useState(null);
  const [showRelatedModal, setShowRelatedModal] = useState(false);
  const [show2, setShow2] = useState(false);
  const [spare, setSpare] = useState("");
  const [spares, setSpares] = useState([]);
  const [brand, setBrand] = useState("");
  const [model, setModel] = useState("");
  const [spareData, setSpareData] = useState([]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (spare) {
      const selectedSpare = spares.find((s) => s[0] === spare);
      setSpareData(selectedSpare ? JSON.parse(selectedSpare[2]) : []);
      setBrand("");
      setModel("");
    }
  }, [spare]);
  const brands = [...new Set(spareData?.map((item) => item.brand))];
  const models = spareData
    ?.filter((item) => item.brand === brand)
    .map((item) => item.model);

  const fetchSpares = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/get_spares`,
        {
          data: sessionStorage.getItem("branch"),
        },
        {
          headers: {
            "x-access-token": sessionStorage.getItem("token"),
          },
        }
      );

      setSpares(response.data);
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching spares:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLowSpares();
    fetchRequested_spares();
    fetchSpares();
    fetchRequested_me();
  }, []);

  const fetchLowSpares = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/search_for_low_spares`,
        {
          branch: sessionStorage.getItem("branch"),
        },
        { headers: { "x-access-token": sessionStorage.getItem("token") } }
      );
      if (response.data.success != 0) {
        setLowSpares(response.data);
      }

      fetchRequested_me();
      fetchRequested_spares();
    } catch (error) {
      console.error("Error fetching low spares:", error);
    } finally {
      setLoading(false);
    }
  };

  const [temp_spare_id, setTemp_spare_id] = useState("");
  const fetchRelatedSpares = async (spareId, brand, model) => {
    setTemp_spare_id(spareId);
    setShowRelatedModal(true);
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/related_spares`,
        { spare_id: spareId, brand, model },
        { headers: { "x-access-token": sessionStorage.getItem("token") } }
      );
      setRelatedSpareRecord(response.data);
      fetchRequested_me();
      fetchRequested_spares();
    } catch (error) {
      console.error("Error fetching related spares:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleRequestClick = (spare) => {
    setSelectedSpareForRequest(
      selectedSpareForRequest === spare.spare_id ? null : spare.spare_id
    );
    setRequestQuantity(spare.difference);
  };

  const handleConfirmRequest = async (spare, branchId, brand, model) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${globalValue}/spare_request_to_admin`,
        {
          requested_spare: spare.spare_id,
          spare_id: temp_spare_id,
          quantity: requestQuantity,
          current_branch: sessionStorage.getItem("branch"),
          to_branch: branchId,
          mobile_no: sessionStorage.getItem("name"),
          brand,
          model,
        },
        { headers: { "x-access-token": sessionStorage.getItem("token") } }
      );

      if (response.data === "success") {
        Swal.fire({ icon: "success", title: "Spare Requested Successfully" });
        fetchLowSpares();
        fetchRequested_me();
        setShowRelatedModal(false);
        fetchRequested_spares();
      } else {
        Swal.fire({ icon: "warning", title: response.data.message });
      }
    } catch (error) {
      console.error("Error requesting spare:", error);
    } finally {
      setLoading(false);
    }
    setSelectedSpareForRequest(null);
  };

  const customStyles = {
    table: {
      style: {
        backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white", // Table background
        width: "100%",
        border:
          theme === "dark"
            ? "solid 1px rgb(63, 62, 62)"
            : "solid 1px rgb(226, 232, 240)",
      },
    },
    headCells: {
      style: {
        backgroundColor:
          theme === "dark" ? "rgb(55, 65, 81)" : "rgb(226, 232, 240)", // Header background
        color: theme === "dark" ? "white" : "black", // Header text
        fontWeight: "bold",
      },
    },
    cells: {
      style: {
        color: theme === "dark" ? "white" : "black",
        backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white",
        border:
          theme === "dark"
            ? "solid 1px rgb(63, 62, 62)"
            : "solid 1px rgb(255, 255, 255)",
      },
    },
    pagination: {
      style: {
        backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white",
        color: theme === "dark" ? "white" : "black",
        borderTop:
          theme === "dark" ? "solid 1px white" : "solid 1px rgb(226, 232, 240)",
      },
      pageButtonsStyle: {
        backgroundColor: theme === "dark" ? "rgb(31, 41, 55)" : "white", // Buttons background
        color: theme === "dark" ? "white" : "black", // Buttons text
        fill: theme === "dark" ? "white" : "black", // Arrow colors
        "&:hover": {
          backgroundColor:
            theme === "dark" ? "rgb(55, 65, 81)" : "rgb(226, 232, 240)", // Hover effect
        },
      },
    },
  };

  const [requested_spare, setRequested_spares] = useState([]);
  const fetchRequested_spares = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${globalValue}/request_spare`, {
        params: {
          data: sessionStorage.getItem("branch"),
          position: "",
        },
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        },
      });
      setRequested_spares(response.data);

      console.log(response.data, "records");
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };
  const [requested_me, setRequested_me] = useState([]);
  const fetchRequested_me = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${globalValue}/request_spare_me`, {
        params: {
          data: sessionStorage.getItem("branch"),
          position: "",
        },
        headers: {
          "x-access-token": sessionStorage.getItem("token"),
        },
      });
      setRequested_me(response.data);
      console.log(response.data, "records");
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const columns1 = [
    {
      name: "Spare Name",
      selector: (row) => row.spare_name,
      sortable: true,
    },
    {
      name: "Requested Spare",
      selector: (row) => row.requested_spare_name,
      sortable: true,
    },
    {
      name: "From",
      selector: (row) => row.from_branch_name,
      sortable: true,
    },
    // {
    //     name: "to",
    //     selector: (row) => row.to_branch_name,
    //     sortable: true,
    // },
    {
      name: "Date",
      selector: (row) =>
        row.date ? new Date(row.date).toLocaleDateString("en-GB") : "",
      sortable: true,
    },
    {
      name: "Quantity",
      selector: (row) => row.quantity,
      sortable: true,
    },
    {
      name: "Mobile_no/Staff",
      selector: (row) => row.mobile_no,
      sortable: true,
    },
  ];

  const columns2 = [
    {
      name: "Spare Name",
      selector: (row) => row.spare_name,
      sortable: true,
    },
    {
      name: "Requested Spare",
      selector: (row) => row.requested_spare_name,
      sortable: true,
    },
    // {
    //     name: "From",
    //     selector: (row) => row.from_branch_name,
    //     sortable: true,
    // },
    {
      name: "to",
      selector: (row) => row.to_branch_name,
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) =>
        row.date ? new Date(row.date).toLocaleDateString("en-GB") : "",
      sortable: true,
    },
    {
      name: "Quantity",
      selector: (row) => row.quantity,
      sortable: true,
    },
    {
      name: "Mobile_no/Staff",
      selector: (row) => row.mobile_no,
      sortable: true,
    },
  ];

  const columns = [
    {
      name: "Spare ID",
      selector: (row) => row.spare_id,
      sortable: true,
    },
    {
      name: "Brand",
      selector: (row) => row.brand,
      sortable: true,
    },
    {
      name: "Model",
      selector: (row) => row.model,
      sortable: true,
    },
    {
      name: "Spare Name",
      selector: (row) => row.spare_name,
      sortable: true,
    },
    {
      name: "Required Quantity",
      selector: (row) => row.required_quantity,
      sortable: true,
    },
    {
      name: "Available Quantity",
      selector: (row) => row.available_quantity,
      sortable: true,
    },
    {
      name: "Difference",
      selector: (row) => row.difference,
      sortable: true,
      cell: (row) => (
        <span className="text-red-500 font-bold">{row.difference}</span>
      ),
    },
    {
      name: "requested spare count",
      selector: (row) => row.requested_spare_count,
      sortable: true,
      cell: (row) => (
        <span className="text-green-500 font-bold">
          {row.requested_spare_count}
        </span>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <button
          className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
          onClick={() => fetchRelatedSpares(row.spare_id, row.brand, row.model)}
        >
          Fetch
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const date = new Date(dateStr);
    return `${String(date.getDate()).padStart(2, "0")}/${String(
      date.getMonth() + 1
    ).padStart(2, "0")}/${date.getFullYear()}`;
  };

  const handleExportPDF = () => {
    const doc = new jsPDF();
    doc.text("JALS AUTOMOBILES", 14, 10);
    let rows = [];
    let columns = [];
    console.log(lowSpares, "PPP");
    columns = ["Spare Name", "Brand", "Model", "Low Quantity"];
    rows = lowSpares.map((row) => [
      row.spare_name,
      row.brand,
      row.model,
      row.required_quantity,
    ]);

    autoTable(doc, { head: [columns], body: rows, startY: 15 });
    doc.save(`low_spare_report.pdf`);
  };

  return (
    <div
      className={`md:ml-[250px] w-full md:w-[calc(100%-250px)] mt-16 h-[92vh] flex justify-center items-center box-border ${
        theme === "dark"
          ? "bg-gray-900 text-white"
          : "bg-gray-100 text-gray-800"
      }`}
    >
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-200 bg-opacity-50 z-50">
          <img src={engineGif} alt="Loading..." className="w-24 h-24" />
        </div>
      )}
      <div
        className={`w-[95%] md:w-[98%] h-[95%] px-4 py-2 rounded-xl shadow-xl overflow-auto ${
          theme === "dark"
            ? "bg-gray-800 text-gray-200"
            : "bg-white text-gray-800"
        }`}
      >
        {" "}
        <div className="w-full flex justify-between text-gray-600">
          <Head_data data="Manage Spares" font="" size="3xl" />

          <button
            onClick={() => {
              setShow2(true);
              setSpare("");
            }}
            className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700 md:mt-2"
          >
            Request Spare
          </button>
        </div>
        <h2 className="text-xl font-bold mb-4">Low Spare Items</h2>
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Report Summary</h2>
          <button
            onClick={handleExportPDF}
            className="px-4 py-2 text-white bg-green-600 hover:bg-green-700 rounded"
          >
            Export PDF
          </button>
        </div>
        <DataTable
          columns={columns}
          data={lowSpares}
          pagination
          highlightOnHover
          striped
          responsive
          customStyles={customStyles}
        />
        <h2 className="text-xl font-bold mb-2">Requested Spares</h2>
        <DataTable
          columns={columns2}
          data={requested_me}
          pagination
          highlightOnHover
          striped
          responsive
          customStyles={customStyles}
        />
        <h2 className="text-xl font-bold mb-2">Requests from other branch</h2>
        <DataTable
          columns={columns1}
          data={requested_spare}
          pagination
          highlightOnHover
          striped
          responsive
          customStyles={customStyles}
        />
      </div>

      <Modal show={show2} onClose={() => setShow2(false)}>
        <Modal.Header className="flowbite-modal-h">
          Select Spare to Fetch
        </Modal.Header>
        <Modal.Body className="flowbite-modal-h">
          <div>
            <Label>Select Spare</Label>
            <Select
              value={spare}
              onChange={(e) => {
                setSpare(e.target.value);
                setBrand("");
                setModel("");
              }}
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              maxMenuHeight={130}
            >
              <option value="" disabled>
                Select Spare
              </option>
              {spares.map((spareItem) => (
                <option key={spareItem[0]} value={spareItem[0]}>
                  {spareItem[1]}
                </option>
              ))}
            </Select>
          </div>

          {spare && (
            <div className="mt-3">
              <Label>Select Brand</Label>
              <Select
                value={brand}
                onChange={(e) => {
                  setBrand(e.target.value);
                  setModel("");
                }}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                maxMenuHeight={130}
              >
                <option value="" disabled>
                  Select Brand
                </option>
                {spares.find((s) => s[0] === spare)?.[2]
                  ? [
                      ...new Set(
                        JSON.parse(spares.find((s) => s[0] === spare)[2]).map(
                          (item) => item.brand
                        )
                      ),
                    ].map((brandName) => (
                      <option key={brandName} value={brandName}>
                        {brandName}
                      </option>
                    ))
                  : null}
              </Select>
            </div>
          )}

          {brand && (
            <div className="mt-3">
              <Label>Select Model</Label>
              <Select
                value={model}
                onChange={(e) => {
                  setModel(e.target.value);

                  const selectedSpareData = JSON.parse(
                    spares.find((s) => s[0] === spare)?.[2] || "[]"
                  );
                  const selectedModel = selectedSpareData.find(
                    (data) =>
                      data.brand === brand && data.model === e.target.value
                  );
                }}
                menuPortalTarget={document.body}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                maxMenuHeight={130}
              >
                <option value="" disabled>
                  Select Model
                </option>
                {spares.find((s) => s[0] === spare)?.[2]
                  ? JSON.parse(spares.find((s) => s[0] === spare)[2])
                      .filter((item) => item.brand === brand)
                      .map((item) => (
                        <option key={item.model} value={item.model}>
                          {item.model}
                        </option>
                      ))
                  : null}
              </Select>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer className="flowbite-modal-h">
          <Button
            disabled={!spare || !brand || !model}
            onClick={() => {
              fetchRelatedSpares(spare, brand, model);
              setShow2(false);
            }}
          >
            Fetch
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showRelatedModal}
        onClose={() => setShowRelatedModal(false)}
        size="4xl"
      >
        <Modal.Header className="flowbite-modal-h">
          Related Spares from Other Branches
        </Modal.Header>
        <Modal.Body className="flowbite-modal-h">
          {relatedSpareRecord.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border border-gray-300 p-2">Spare ID</th>
                    <th className="border border-gray-300 p-2">Spare Name</th>
                    <th className="border border-gray-300 p-2">Brand</th>
                    <th className="border border-gray-300 p-2">Model</th>
                    <th className="border border-gray-300 p-2">Quantity</th>
                    <th className="border border-gray-300 p-2">Branch</th>

                    <th className="border border-gray-300 p-2">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {relatedSpareRecord.map((spare, index) => (
                    <React.Fragment key={index}>
                      <tr className="text-center">
                        <td className="border border-gray-300 p-2">
                          {spare.spare_id}
                        </td>
                        <td className="border border-gray-300 p-2">
                          {spare.spare_name}
                        </td>
                        <td className="border border-gray-300 p-2">
                          {spare.brand}
                        </td>
                        <td className="border border-gray-300 p-2">
                          {spare.model}
                        </td>
                        <td className="border border-gray-300 p-2">
                          {spare.quantity}
                        </td>
                        <td className="border border-gray-300 p-2">
                          {spare.branch_name}
                        </td>
                        <td className="border border-gray-300 p-2">
                          <button
                            className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600"
                            onClick={() => handleRequestClick(spare)}
                          >
                            Request
                          </button>
                        </td>
                      </tr>

                      {selectedSpareForRequest === spare.spare_id && (
                        <tr>
                          <td
                            colSpan="7"
                            className="p-2 border border-gray-300"
                          >
                            <div className="flex items-center justify-center gap-4">
                              <input
                                type="number"
                                min="1"
                                className="p-2 border rounded w-full"
                                value={requestQuantity}
                                onChange={(e) =>
                                  setRequestQuantity(e.target.value)
                                }
                              />
                              <button
                                className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                                onClick={() =>
                                  handleConfirmRequest(
                                    spare,
                                    spare.branch_id,
                                    spare.brand,
                                    spare.model
                                  )
                                }
                              >
                                Confirm
                              </button>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <p className="text-center text-gray-500">
              No related spares available.
            </p>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SpareRequests;
